import { Pipe, PipeTransform } from '@angular/core';
import { padStart } from 'lodash-es';

@Pipe({
  name: 'secondsToDuration',
})
export class SecondsToDurationPipe implements PipeTransform {
  transform(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    const padZero = (value: number) => padStart(value.toString(), 2, '0');

    return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
  }
}
